import axios from 'axios';
import { IDENTITY_URL } from 'constants/api';

export const getIdentity = () => {
    const url = `${ process.env.API_URL }${ IDENTITY_URL }?include_account_data=true&include_intercom_identity=true`;
    return () => {
        return axios.get(url, { withCredentials: true }).then((data) => {
            return data;
        });
    };
};
